import { TenantWithBuildingTree } from "../types/response/tenant";

/**
 * テナント＞マーケット＞エリア＞ビルのネスト構造から
 * ビルIDとマーケット/エリア/ビルのパス名のリストを作成する
 */
export const flattenBuildings = (tenant?: TenantWithBuildingTree) => {
  const result: {
    buildingId: string;
    pathName: string;
  }[] = [];
  if (!tenant) return result;

  for (const market of tenant.markets) {
    if (!market.areas.length) continue;
    for (const area of market.areas) {
      if (!area.buildings.length) continue;
      for (const building of area.buildings) {
        result.push({
          buildingId: building.buildingId,
          pathName: `${market.marketName} / ${area.areaName} / ${building.buildingName}`,
        });
      }
    }
  }
  return result;
};

type Params = {
  tenant?: TenantWithBuildingTree;
  marketIds?: string[];
  areaIds?: string[];
};

export const flattenBuildingsFiltered = (input: Params) => {
  const tenant = input.tenant;
  const result: {
    buildingId: string;
    pathName: string;
  }[] = [];
  if (!tenant) return result;

  if (input.marketIds) {
    for (const market of tenant.markets) {
      if (!input.marketIds.includes(market.marketId)) continue;

      if (!market.areas.length) continue;
      for (const area of market.areas) {
        if (!area.buildings.length) continue;
        for (const building of area.buildings) {
          result.push({
            buildingId: building.buildingId,
            pathName: `${market.marketName} / ${area.areaName} / ${building.buildingName}`,
          });
        }
      }
    }
  } else if (input.areaIds) {
    for (const market of tenant.markets) {
      if (!market.areas.length) continue;
      for (const area of market.areas) {
        if (!input.areaIds.includes(area.areaId)) continue;
        if (!area.buildings.length) continue;
        for (const building of area.buildings) {
          result.push({
            buildingId: building.buildingId,
            pathName: `${market.marketName} / ${area.areaName} / ${building.buildingName}`,
          });
        }
      }
    }
  } else {
    for (const market of tenant.markets) {
      if (!market.areas.length) continue;
      for (const area of market.areas) {
        if (!area.buildings.length) continue;
        for (const building of area.buildings) {
          result.push({
            buildingId: building.buildingId,
            pathName: `${market.marketName} / ${area.areaName} / ${building.buildingName}`,
          });
        }
      }
    }
  }

  return result;
};
